import * as z from "zod";

/**
 * Fetch pre-fill values for the admin "Provision phone number" modal.
 * Returns the team's stored address + owner contact plus any previously
 * saved `rec-business-info` form data (legal entity, EIN, brand name,
 * support email, TCR fields) so ops doesn't re-type known fields.
 *
 * Any missing field comes back `null`; the client falls back to its
 * DEFAULT_FORM for those.
 */
export const getTeamRecoverProvisioningDefaults = {
  name: "getTeamRecoverProvisioningDefaults" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    address: z
      .object({
        street1: z.string().nullable(),
        street2: z.string().nullable(),
        city: z.string().nullable(),
        state: z.string().nullable(),
        zip: z.string().nullable(),
        country: z.string().nullable(),
      })
      .nullable(),
    adminName: z.string().nullable(),
    adminPhone: z.string().nullable(),
    storeUrl: z.string().nullable(),
    businessInfo: z
      .object({
        legalEntityName: z.string().nullable(),
        ein: z.string().nullable(),
        brandName: z.string().nullable(),
        supportEmail: z.string().nullable(),
        businessType: z.string().nullable(),
        industryVertical: z.string().nullable(),
        contactJobTitle: z.string().nullable(),
      })
      .nullable(),
  }),
};
